import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Alert, AnimatedCircleStatus, Button, Card, Main, PageHeader, Skeleton } from '../../Components'
import { automateMonitoringService, componentStatus, incidentImpact, incidentStatus } from '../../Constants/Constants'
import axios from 'axios'
import Tooltip from 'rc-tooltip'
import moment from 'moment'
import { TbDatabaseImport } from 'react-icons/tb'
import { useConfirmationModal } from '../../Hooks/useNotifications'
import { AiOutlineSetting } from 'react-icons/ai'
import { BiLinkExternal } from 'react-icons/bi'
import './statuspages.css'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
export function StatuspageDetails() {


	const { page_id } = useParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)
    const { getConfirmation } = useConfirmationModal();
    const { user , org } = useSelector((state) => state.auth)

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingStatuspageData, setIsLoadingStatuspageData] = useState(true)
	const [isLoadingIncidents, setIsLoadingIncidents] = useState(true)
	const [pageData, setPageData] = useState({})
	const [incidents, setIncidents] = useState([])



	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			getStatuspageData();
			getIncidents({
				page : 0,
				per_page : 5
			});
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])


	/**
	 * 
	 * @returns 
	 */
	const getStatuspageData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingStatuspageData(true)
			// 
			// //
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setPageData(data)

					setIsLoadingStatuspageData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
                    if(error?.response?.data?.error ==='NOT_FOUND'){
						navigate('/pages')
					}
					setIsLoadingStatuspageData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingStatuspageData(false)
			}

		})
	} 

	/**
	 * GET INCIDENTS LIST ( SHORT LIST )
	 */
	const getIncidents = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingIncidents(true)
			
			//
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					status : 'opened'
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/incidents` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					 

					setIncidents(data.data)

					setIsLoadingIncidents(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoadingIncidents(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setIncidents([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingIncidents(false)
			}

		})
	}

    const openDeletePageModal = (params) => {
		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Delete this page",
			message: "As a product admin, you can mark this page for deletion. This will trigger an email to other product admins, notifying them of this deletion. Any admin will be able to cancel this deletion for 10 days before the page is ultimately deleted.\n The deletion will be final and non-recoverable after the 10 days have passed.",
			labels: { confirm: 'Schedule Page deletion', cancel: "No don't delete it" },
			onConfirm : () => {
				scheduleDeletePage(params?.id)
			},
			onCancel : () => {
				 

			}
		});
	}

    const scheduleDeletePage = (PAGE_ID) => {

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			//
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}`, {
					params : {},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

                    setPageData(prevState => ({
                        ...prevState,
                        start_delete_at : data?.start_delete_at
                    }))
					// setIsLoading(false)
					toast.success('You have requested your page be deleted within the next 10 days. You can still cancel the deletion') 
					


					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})
	}
    const cancelDeletePageModal = (params) => {
		getConfirmation({
			size : 'small',
			type: '',
			title: "Cancel Status page deletion",
			message: "You are about to cancel the pending deletion of this status page. Your status page will then no longer be deleted.",
			labels: { confirm: 'Cancel Deletion', cancel: "Back" },
			onConfirm : () => {
				cancelScheduleDeletePage(params?.id)
			},
			onCancel : () => {
				 

			}
		});
	}

    const cancelScheduleDeletePage = (PAGE_ID) => {

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			//
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}`, {
                    cancel_deleting : true 
                    },{
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

                    setPageData(prevState => ({
                        ...prevState,
                        start_delete_at : null 
                    }))
					// setIsLoading(false)
					toast.success('Your page is no longer marked for deletion.') 
					


					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})
	}



	return (
		<>
		<Helmet>
            <title>{`Page overview - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: '/pages' },
				{ name: 'Page Overview', link: '' },
			]}
			 >
				<PageHeader
                    isLoading={isLoadingStatuspageData}
					title={`${pageData?.name}'s page overview`}
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
                    actionBtns={[
                        {
                            type : 'component',
                            component : (
                                pageData?.start_delete_at !== null
                                ? <Tooltip
                                    placement="top" 
                                    trigger={['hover']} 
                                    overlay={<span style={{ maxWidth : '100px'}}>{`The final deletion date has been set for ${moment(pageData?.start_delete_at).format('MMM D, YYYY [at] hh:mm A')}`}</span>}
                                    >
                                        <Button  onClick={() => cancelDeletePageModal({ id : pageData?.id })} >Cancel delete page</Button>
                                        </Tooltip>
                                : <Button color="red" onClick={() => openDeletePageModal({ id : pageData?.id })} >Delete page</Button>
                            )
                        },
                        {
                            type : 'component',
                            component :
                                <Tooltip
                                    placement="top" 
                                    trigger={['hover']} 
                                    overlay={<span style={{ maxWidth : '100px'}}>{`View status page`}</span>}
                                >
                                <a target="_blanc" href={
                                    pageData?.custom_domain!=null 
                                    ? `https://${pageData?.custom_domain}` 
                                    : (
                                        pageData?.hosted_subdomain !==null 
                                        ? `https://${pageData?.hosted_subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`
                                        : ''
                                        )
                                }>
                                    <Button color="blue" className='btn btn-purple' ><BiLinkExternal style={{ width : '15px' , height : '15px'}}/></Button>
                                    </a>
                                    </Tooltip>
                        },
                        {
                            type : 'component',
                            component :<Link to={`/pages/${page_id}/settings`}><Button color="blue" className='btn btn-gray' ><AiOutlineSetting style={{ width : '15px' , height : '15px'}}/></Button></Link>
                        },
                    ]}
					/>
					<div className="page-details">
						<div className="main-keys">
							<div className="card-data components">
								<div className="cd-title" >
									{
										isLoadingStatuspageData === true 
										? <Skeleton width={100} height={18}/>
										: <Link to={`/pages/${page_id}/components`}>Components</Link>
									}
								</div>
								<div className="cd-total_number">{
									isLoadingStatuspageData === true 
									? <Skeleton width={40} height={40} radius="sm"/>
									: pageData?.components?.total ?? 0}</div>
								<div className="components-status">
									{
										isLoadingStatuspageData === true 
										? <>
											<Skeleton width="100%" height={18} />
										</>
										:  <ul>
										{
											componentStatus.map( (item , index) => {
												return (
													<Tooltip
														key={index}	
														placement="top" 
														trigger={['hover']} 
														overlay={<span>{`${item?.label}`}</span>}
														>
														<li >
															<span className="icon">{item?.icon}</span>
															<label htmlFor="">{pageData?.components?.status[item?.value] ?? 0}</label>															 
														</li>
													</Tooltip>
												)
											})
										}
										</ul>
									}
								</div> 
							</div>
							<div className="card-data incidents">
								{/* <div className="cd-title">
									<Link to={`/pages/${page_id}/components`}>Incidents</Link></div>
								<div className="cd-total_number">{pageData?.incidents?.total ?? 0}</div> */}
								<div className="cd-title" >
									{
										isLoadingStatuspageData === true 
										? <Skeleton width={100} height={18}/>
										: <Link to={`/pages/${page_id}/incidents`}>Incidents</Link>
									}
								</div>
								<div className="cd-total_number">{
									isLoadingStatuspageData === true 
									? <Skeleton width={40} height={40} radius="sm"/>
									: pageData?.incidents?.total ?? 0}</div>
								<div className="incidents-status">
									{
										isLoadingStatuspageData === true 
										? <>
											<Skeleton width="100%" height={18} />
										</>
										:  
										<ul>
											<li className='resolved-incidents'><span>{pageData?.incidents?.status['RESOLVED'] ?? 0}</span><label htmlFor="">Resolved</label></li>
											<li className='open-incidents'><span>{(pageData?.incidents?.total - (pageData?.incidents?.status['RESOLVED'] ?? 0))}</span><label htmlFor="">Open incidents</label></li>
										</ul>
									}
								</div>
							</div>
						</div>
						<div className="short-list open-incidents">
							<div className="slist-title">Last open incidents <Link className="show-more" to={`/pages/${page_id}/incidents`}>Show All incidents</Link></div>
							{
								isLoadingIncidents === true 
								? 
								<>
								<div className="mb-20">
									<Skeleton className="mb-10" width="60%" height={18} />
									<Skeleton className="mb-5" width="80%" height={14} />
								</div>
								<div className="mb-20">
									<Skeleton className="mb-10" width="40%" height={18} />
									<Skeleton className="mb-5" width="50%" height={14} />
								</div>
								<div className="mb-20">
									<Skeleton className="mb-10" width="30%" height={18} />
									<Skeleton className="mb-5" width="60%" height={14} />
								</div>
								<div className="mb-20">
									<Skeleton className="mb-10" width="50%" height={18} />
									<Skeleton className="mb-5" width="70%" height={14} />
								</div>
								</>
								: (
									incidents.length <= 0 
									? <Alert color={'success'} >No incidents found</Alert>
									: 
									incidents.map( (item , index) => {

										const _lastUpdate = (item?.updates !==null && item?.updates?.length > 0) 
										? incidentStatus.find( x => x.id === item?.updates[0]?.status)
										: null ;
										return (
											<Card key={index} shadow="sm" className='incident-item' >
												<div className='incident-wrapper'>
													<div className='incident-status'>
														<AnimatedCircleStatus 
															status={ incidentImpact.find(x =>x.id === item?.impact)?.color ?? 'none' }
														/>
													</div>
													<div className='incident-main_content'>
														<Link 
															className='incident-title'
															to={`/pages/${page_id}/incidents/${item?.id}/edit`}
															
															>{item?.name}
															</Link>
														<div className='incident-desc'>
															{ _lastUpdate &&  
																<div className='tag-wrapper'>
																	<div className={`tag ${_lastUpdate?.id}`} >{ _lastUpdate?.name}</div>
																</div>
															}
															<div className='date'>{`Last update on ${moment(_lastUpdate?.updated_at).format('dddd, MMMM Do YYYY, h:mm A')}`}</div>	
														</div>
													</div>
													<div className='incident-actions'>
														{
															item?.updates !==null && item?.updates?.length && item?.updates[0]?.automation_source !==null && 
															<Tooltip
																placement="top" 
																trigger={['hover']} 
																overlay={<span>{`This incident was generated automatically from the ${automateMonitoringService?.find( x => x.value === item?.updates[0]?.automation_source)?.label} monitoring service`}</span>}
															>
																<div className="automation_source-tag"><TbDatabaseImport />{ automateMonitoringService?.find( x => x.value === item?.updates[0]?.automation_source)?.label }</div>
															</Tooltip>
														}
													</div>
													
												</div>
											</Card>
										)
									})
								)
							}		
						</div>
					</div>
		</Main>
		</>
	)
}
